export default __webpack_public_path__ + "static/media/Others_Snooze.8cca2600.svg";